var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCirclePlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 25,
    width: 25,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    fill: "#fff",
    r: 12.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.893 7a.75.75 0 01.75.75v4.393h4.607a.75.75 0 010 1.5h-4.607v4.607a.75.75 0 01-1.5 0v-4.607H7.75a.75.75 0 010-1.5h4.393V7.75a.75.75 0 01.75-.75z",
    fill: "#000"
  })));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-circle-plus-965293905be20b37d45e1f84302bca77.svg";
export { SvgIconCirclePlus as Component };